import React from "react";
import "./Header.css";
function Header() {
  return (
    <header className="header">
      <img className="img_clock" src="img/clock.svg" alt="" />
      <img className="img_title" src="img/title.png" alt="" />
    </header>
  );
}

export default Header;
